import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';

import { UiModule } from '@lockton-apps/shared/ui/lui';
import { DateRangePickerTypeComponent } from './date-range-picker-type.component';

@NgModule({
  declarations: [DateRangePickerTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    UiModule,
    MatIconModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'date-range-picker',
          component: DateRangePickerTypeComponent,
          wrappers: ['mat-form-field', 'addons'],
          defaultOptions: {
            // TODO: upgrade error => Cannot read properties of undefined (reading 'shouldLabelFloat')
            // Having 'mat-label' inside mat-form-field-wrapper is causing the error for this field only
            props: { useExternalLabel: true },
            fieldGroup: [{ key: 'dateFrom' }, { key: 'dateTo' }],
          },
        },
      ],
    }),
  ],
})
export class DateRangePickerTypeModule {}
